// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"16d4fd9d","703":"844a098b"}[chunkId] + ".chunk.js";
};